import React from "react";

import { useAuthState } from "src/features/auth/hooks/useAuthState";
import { Permission } from "src/features/auth/types";
import { useOrgModParams } from "src/features/orgmod";

export function useHasPermission(permission: Permission): boolean {
	const { user } = useAuthState();
	const { org, mod } = useOrgModParams();
	return React.useMemo(
		() =>
			user?.permissions.some(
				item =>
					item.permission === permission &&
					item.organization === org &&
					item.module === mod
			) ?? false,
		[permission, user, org, mod]
	);
}
